import { BaseHttpService } from './base-http.service'

export default new (class InviteCooperateHistoryService extends BaseHttpService {
    getInviteCooperateHistory(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
})()